// Must load first: namespaces localStorage so this app does not share a
// session with the staff / shareholder builds on the same origin.
import './system/storage/scope';

// Init theme before render (mirrors admin ui template inline script)
try {
  const t = localStorage.getItem('dash26-theme');
  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  document.documentElement.setAttribute('data-theme', t || (prefersDark ? 'dark' : 'light'));
} catch (e) {
  document.documentElement.setAttribute('data-theme', 'light');
}

import Vue from 'vue'
import App from './App.vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/admin-ui.css'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import hint from './system/hint'
import './assets/variable.scss'
import i18n from "./system/lang/lang.js";
import router from "./router";
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import VueQRCodeComponent from 'vue-qrcode-component';
import { routes } from '@/router';
import {
  readTabs,
  readActiveTab,
  writeTabs,
  writeActiveTab,
} from '@/system/tabs/tabStorage';


Vue.use(VueSweetalert2);
Vue.use(BootstrapVue);
Vue.use(hint);
Vue.use(IconsPlugin);
Vue.component('qr-code', VueQRCodeComponent);


Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  render: h => h(App),
  data() {
    return {
      isLoading: false,
      userTree: [],
      paths: [],
      permittedPath: [],
      actionPaths: [],
      tabs: [],
      activeTab: '',
      tabComponents: {},
    }
  },
  created() {
    this.loadUserTabs();
  },
  methods: {
    loadUserTabs() {
      const username = localStorage.getItem('username') || '';
      if (!username) {
        this.tabs = [];
        this.activeTab = '';
        this.tabComponents = {};
        return;
      }
      this.tabs = readTabs(username);
      this.activeTab = readActiveTab(username);
      this.tabComponents = {};
    },
    persistTabs() {
      writeTabs(this.tabs);
    },
    persistActiveTab() {
      writeActiveTab(this.activeTab);
    },
    resetSessionTabs() {
      this.tabs = [];
      this.activeTab = '';
      this.tabComponents = {};
    },
    async checkPermission() {
      // console.log('permission check');
      this.paths = [];
      this.permittedPath = [];

      var roleInfo = await localStorage.getItem('path') || '';
      try {
        roleInfo = JSON.parse(roleInfo);
      } catch (error) {
        roleInfo = { page: '', edit_action: '' };
      }
      if (!roleInfo.page) roleInfo.page = '';
      if (!roleInfo.edit_action) roleInfo.edit_action = '';

      var userPath = (roleInfo.page).split(',');

      // console.log(userPath)

      routes.forEach((path, index) => {
        if (index == 0) {
          if (path.children) {
            var children = path.children;
            this.paths = children;
          }
        }
      });

      var tmpList = [];
      this.paths.forEach((el) => {
        var children = [];
        (el.children || []).forEach((child) => {
          if (child.meta) {
            const perm = child.meta.permission.toString();
            if (child.meta.always || userPath.includes(perm)) {
              this.permittedPath.push(child);
              children.push(child);
            }
          }
        });
        if (children.length > 0) {
          el.children = children;
          tmpList.push(el);

        }
      });

      var actionPath = (roleInfo.edit_action).split(',');
      // console.log(actionPath);
      this.actionPaths = [];
      actionPath.forEach(element => {
        const perm = element.toString();
        if (!perm) return;
        this.actionPaths.push(perm);
      });
      this.paths = tmpList;
    },
    changeLan(lang) {
      localStorage.setItem('lan', lang);
      this.$i18n.locale = lang;

    },
    openTab(path, label, username = '') {
      const existing = this.tabs.find(t => t.path === path);
      const id = existing ? existing.id : path + '_' + Date.now();
      if (!existing) {
        this.tabs.push({ id, path, label, username });
        this.persistTabs();
      }
      this.activeTab = id;
      this.persistActiveTab();
      this.$router.push(path).catch(() => {}).then(() => {
        if (this.tabComponents[id]) return;
        const matched = this.$router.currentRoute.matched;
        const leaf = matched[matched.length - 1];
        if (leaf && leaf.components && leaf.components.default) {
          this.$set(this.tabComponents, id, leaf.components.default);
        }
      });
    },
    closeTab(id) {
      this.$delete(this.tabComponents, id);
      const idx = this.tabs.findIndex(t => t.id === id);
      if (idx === -1) return;
      this.tabs.splice(idx, 1);
      this.persistTabs();
      if (this.activeTab === id) {
        const next = this.tabs[idx] || this.tabs[idx - 1];
        if (next) {
          this.activeTab = next.id;
          this.persistActiveTab();
          if (!this.tabComponents[next.id]) {
            const route = this.$router.resolve(next.path);
            const matched = route && route.resolved && route.resolved.matched;
            const leaf = matched && matched[matched.length - 1];
            const loader = leaf && leaf.path !== '*' && leaf.components && leaf.components.default;
            if (loader) this.$set(this.tabComponents, next.id, loader);
          }
          if (this.$route.fullPath !== next.path) this.$router.push(next.path).catch(() => {});
        } else {
          this.activeTab = '';
          this.persistActiveTab();
        }
      }
    },
    closeAllTabs() {
      Object.keys(this.tabComponents).forEach((id) => {
        this.$delete(this.tabComponents, id);
      });
      this.tabs = [];
      this.activeTab = '';
      this.persistTabs();
      this.persistActiveTab();
      this.$router.push('/manage/dashboard/dashboard').catch(() => {});
    },
    makeToast(type, msg) {
      const text = this.$te(msg) ? this.$t(msg) : msg;
      this.$emit('toast', { type, msg: text });
    },
  }
}).$mount('#app')
